import React from 'react'
import PropTypes from 'prop-types'

function Spinner({
  hasShadow,
}) {
  return (
    <div className={`mz-spinner ${hasShadow ? 'mz-spinner--shadow' : ''}`}>
      <div className="mz-spinner-circle"></div>
    </div>
  )
}

Spinner.propTypes = {
  hasShadow: PropTypes.bool
}

Spinner.defaultProps = {
  hasShadow: false
}

export default Spinner